import { createSelector } from 'reselect'
import productTypes from 'helpers/enums/productTypes'
import slideTypes from 'helpers/enums/slideTypes'
import { getFlag } from 'helpers/featureFlags/provider'
import userEmailSelector from 'redux/selectors/user/user_email_selector'
import getActivityList from 'views/google_slides/helpers/slides_list'

const userDataSelector = state => state.user.data
const externalSlidesSelector = state => state.external
const getActivityEnabled = (activity, roleId) => {
	const flagEnabled = activity.flagType ? getFlag(activity.flagType) : true
	const reverseFlagEnabled = activity.reverseFlagType ? getFlag(activity.reverseFlagType) : false
	const roleEnabled = activity.roles.length === 0 || activity.roles.includes(roleId)

	return flagEnabled && roleEnabled && !reverseFlagEnabled
}
const canAddFlocabulary = (activity, canAddFlocabulary) => {
	if (activity.id === slideTypes.SLIDE_TYPE_ID_FLOCABULARY) {
		return canAddFlocabulary
	}

	return true
}

export default createSelector(
	[ userDataSelector, userEmailSelector, externalSlidesSelector ],
	(userData, email, external) => {
		let roleId = ''
		if (userData.account) {
			roleId = userData.account.typeId
			if (userData.account.featuresTrial && userData.account.featuresTrial.type === 1) {
				roleId = productTypes.GOLD
			}

		}

		const isCurrentSlideFromNearpod = external.slides[external.currentSlideIndex] &&
			external.slides[external.currentSlideIndex].slideTypeId !== -1

		const activityList = getActivityList()
		const activitiesEnabled = activityList.filter(
			activity => (roleId && getActivityEnabled(activity, roleId))
		).filter(activity => canAddFlocabulary(activity, userData.canAddFlocabulary))

		return {
			roleId,
			email,
			slides: external.slides,
			currentSlideIndex: external.currentSlideIndex,
			isCurrentSlideFromNearpod,
			activities: activitiesEnabled,
		}
	}
)
